import { Component, Inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { EnvironmentService } from './core/services/environment.service';
import { AnnouncementsService } from './core/services/announcements.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnnouncementModalComponent } from './shared/components/announcement-modal/announcement-modal.component';
import { IAuthService } from './core/interfaces/i-auth.service';
import { filter, take } from 'rxjs/operators';
import { Announcement } from './core/models/announcement';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent {
  constructor(
    private environmentService: EnvironmentService,
    private title: Title,
    private announcements: AnnouncementsService,
    private modalService: NgbModal,
    @Inject('IAuthService') private authService: IAuthService
  ) {}
  
  ngOnInit() {
    this.title.setTitle(this.environmentService.environment.welcome.message?.replace(/<.*?>/g, '') || 'CartoAF');

    if(this.environmentService.environment.apiAnnouncements?.length) {
      this.authService.isUserLogged.pipe(
        filter(isLogged => isLogged === true),
        take(1)
      ).subscribe(() => {
        this.announcements.getAnnouncements().subscribe(list => {
          const activeAnnouncements = this.announcements.sortAnnouncements(list)
            .filter(a => this.announcements.shouldShow(a));
          
          this.showAnnouncementsSequentially(activeAnnouncements, 0);
        });
      });
    }
  }

  private showAnnouncementsSequentially(announcements: Announcement[], index: number): void {
    if (index >= announcements.length) return;

    const announcement = announcements[index];
    const modalRef = this.modalService.open(AnnouncementModalComponent, {
      size: 'lg',
      scrollable: true,
      windowClass: 'center-modal',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.announcement = announcement;

    modalRef.result.then(result => {
      if (result === 'suppress') {
        this.announcements.markDismissed(announcement);
      }
      this.showAnnouncementsSequentially(announcements, index + 1);
    }).catch(() => {
      this.showAnnouncementsSequentially(announcements, index + 1);
    });
  }
}
